import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import Alert from '../../../../../components/Alert';
import Button from '../../../../../components/Button';
import Tooltip from '../../../../../components/Tooltip';
import { i18nNS } from '../../../../../i18n';
import RocketIcon from '../../../../../icons/RocketIcon';
import ErrorsList from '../../ErrorsList';
import EditPublishPreferencesDrawer from '../EditPublishPreferencesDrawer';
import usePublishPoll, { UsePublishPoll } from './vm';

export interface PublishPollProps extends UsePublishPoll {
  label?: ReactNode;
  className?: string;
}

const PublishPoll = ({ label, className, ...vmProps }: PublishPollProps) => {
  const { t } = useTranslation([i18nNS.POLL, i18nNS.GLOSSARY]);

  const { errors, isClassClosed } = vmProps;
  const {
    canPublish,
    tooltipTitle,
    handlePublishButtonClick,
    hasErrors,
    canOpenAlert,
    alertBody,
    isPublishPollDrawerOpen,
    handleClosePublishPollDrawer,
    handleCloseAlert,
  } = usePublishPoll(vmProps);

  return (
    <>
      <Tooltip title={label ? null : tooltipTitle}>
        <span>
          <Button
            variant={label ? 'contained' : 'text'}
            size="small"
            disabled={!canPublish || isClassClosed}
            onClick={handlePublishButtonClick}
            aria-label={t('click_to_publish_poll', { ns: i18nNS.POLL })}
            className={className}
            iconOnly={label ? false : true}
          >
            <RocketIcon size={20} aria-hidden />
            {label}
          </Button>
        </span>
      </Tooltip>
      <Alert open={canOpenAlert} onClose={handleCloseAlert} maxWidth="xs">
        <Alert.Body>{hasErrors ? <ErrorsList errors={errors} /> : alertBody}</Alert.Body>
        <Alert.Footer>
          <Alert.Action variant="text">{t('okay', { ns: i18nNS.GLOSSARY })}</Alert.Action>
        </Alert.Footer>
      </Alert>
      <EditPublishPreferencesDrawer
        open={isPublishPollDrawerOpen}
        onClose={handleClosePublishPollDrawer}
        isPublishing
      />
    </>
  );
};

export default PublishPoll;
